export const INSTAGRAM: Record<LocaleKey, string> = {
  pl: "https://www.instagram.com/onlymassage_europe",
  cz: "https://www.instagram.com/onlymassage_europe",
  en: "https://www.instagram.com/onlymassage_simplymassage",
  de: "https://www.instagram.com/onlymassage_simplymassage",
  es: "https://www.instagram.com/onlymassagesudamerica",
  fr: "https://instagram.com/onlymassagefrance",
};
export const FACEBOOK: Record<LocaleKey, string> = {
  pl: "https://facebook.com/onlymassageeurope",
  cz: "https://facebook.com/onlymassageeurope",
  en: "https://www.facebook.com/onlymassageasia",
  de: "https://www.facebook.com/onlymassageasia",
  es: "https://www.facebook.com/onlymassagesudamerica",
  fr: "https://facebook.com/onlymassagefrance",
};

export type LocaleKey = "pl" | "cz" | "en" | "de" | "es" | "fr";
